import { normalizeMarketLatLng } from "../config/market";

export const SHIPPING_GATE = Object.freeze({
  READY: "ready",
  VENDOR_MISSING: "vendor_missing",
  PHONE_INVALID: "phone_invalid",
  ADDRESS_MISSING: "address_missing",
  COORDINATES_INVALID: "coordinates_invalid",
  COVERAGE_PENDING: "coverage_pending",
  COVERAGE_FAILED: "coverage_failed",
  OUT_OF_RANGE: "out_of_range",
  COVERAGE_UNCONFIRMED: "coverage_unconfirmed",
});

export function isValidDeliveryPhone(phone) {
  return String(phone || "").replace(/\D/g, "").length >= 10;
}

export function savedAddressLatLng(address) {
  return normalizeMarketLatLng(address?.latLng?.lat, address?.latLng?.lng);
}

/**
 * One fail-closed checkout contract for every vendor type.
 *
 * A readable address is not enough: the selected point must be valid for the
 * active market and the backend must positively confirm delivery coverage.
 */
export function evaluateShippingGate({
  phone,
  address,
  lat,
  lng,
  hasChosenAddress,
  vendorId,
  coverage,
}) {
  if (!vendorId) return { canContinue: false, code: SHIPPING_GATE.VENDOR_MISSING };
  if (!isValidDeliveryPhone(phone)) {
    return { canContinue: false, code: SHIPPING_GATE.PHONE_INVALID };
  }
  if (!hasChosenAddress || !String(address || "").trim()) {
    return { canContinue: false, code: SHIPPING_GATE.ADDRESS_MISSING };
  }
  if (!normalizeMarketLatLng(lat, lng)) {
    return { canContinue: false, code: SHIPPING_GATE.COORDINATES_INVALID };
  }
  if (!coverage || coverage.status === "idle" || coverage.status === "loading") {
    return { canContinue: false, code: SHIPPING_GATE.COVERAGE_PENDING };
  }
  if (coverage.status === "failed") {
    return { canContinue: false, code: SHIPPING_GATE.COVERAGE_FAILED };
  }
  if (coverage.deliverable === false || coverage.reason === "OUT_OF_RANGE") {
    return { canContinue: false, code: SHIPPING_GATE.OUT_OF_RANGE };
  }
  if (coverage.status !== "succeeded" || coverage.deliverable !== true) {
    return { canContinue: false, code: SHIPPING_GATE.COVERAGE_UNCONFIRMED };
  }
  return { canContinue: true, code: SHIPPING_GATE.READY };
}

export function shippingGateLabel(code) {
  switch (code) {
    case SHIPPING_GATE.VENDOR_MISSING:
      return "Cart session expired — reopen your cart";
    case SHIPPING_GATE.PHONE_INVALID:
      return "Enter a valid phone number";
    case SHIPPING_GATE.ADDRESS_MISSING:
      return "Choose a delivery address";
    case SHIPPING_GATE.COORDINATES_INVALID:
      return "Update the location pin";
    case SHIPPING_GATE.COVERAGE_PENDING:
      return "Checking delivery coverage…";
    case SHIPPING_GATE.COVERAGE_FAILED:
      return "Delivery check failed — retry above";
    case SHIPPING_GATE.OUT_OF_RANGE:
      return "Vendor doesn't deliver here";
    case SHIPPING_GATE.COVERAGE_UNCONFIRMED:
      return "Delivery could not be confirmed";
    default:
      return "Continue";
  }
}
